import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {useGetCartQuery} from 'modules/cart/services';
import {selectProductData} from 'modules/product-card/selectors';
import {useMemo} from 'react';

export const useGetProductInCart = () => {
    const product = useAppSelector(selectProductData);
    const {data: cart} = useGetCartQuery({mini: true});

    return useMemo(() => {
        if (!cart || !product) {
            return undefined;
        }

        return cart.products.find(({offerId}) => offerId === product.offerId);
    }, [cart, product]);
};
